import { render, staticRenderFns } from "./IntegrationsMappingForm.vue?vue&type=template&id=0bd49da6&scoped=true"
import script from "./IntegrationsMappingForm.vue?vue&type=script&lang=js"
export * from "./IntegrationsMappingForm.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsMappingForm.vue?vue&type=style&index=0&id=0bd49da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd49da6",
  null
  
)

export default component.exports